import { NotificationService } from 'src/app/shared/services/notification.service';
import { HelperService } from 'src/app/_services/helper.service';
import { UploaderConfig } from 'src/app/shared/ecpl-document-explorer/uploader-config';
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators
} from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { inject, Component, OnInit } from '@angular/core';
import { ValidationService } from 'src/app/kuba/shared/services/validation.service';
import { BaseServices } from './../../kuba.services';
import { SelectItem } from 'primeng/api';
import { ManualControlServices } from './../services/manual-control-services';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { FoodControl, FoodControlDocumentDto } from './../models/food-control';

import { Subscription } from 'rxjs';
import { Status } from 'src/app/_models/feature';

interface ManualControlFormControls {
  OrderNumber: FormControl<number | null>;
  objectName: FormControl<string | null>;
  minTemp: FormControl<number | null>;
  maxTemp: FormControl<number | null>;
  Description: FormControl<string | null>;
}

@Component({
  selector: 'manual-control-form',
  styleUrls: ['manual-control-form.component.css'],
  templateUrl: 'manual-control-form.component.html',
  standalone: false
})
export class ManualControlFormComponent implements OnInit {
  private readonly notifications = inject(NotificationService);
  manualControlForm: FormGroup<ManualControlFormControls>;
  temperatureForm: FormGroup;
  TemperatureMin: SelectItem[];
  TemperatureMax: SelectItem[];
  isTempValid = true;
  minTemperature: number | null = null;
  maxTemperature: number | null = null;
  ObjectName: any;
  manualId: number;
  createdOn: any;
  parentId: number;
  manual: any;
  upConfig: UploaderConfig;
  uploadedFiles: any[] = [];
  additionalData: any;
  newUploadedFiles: any | FoodControlDocumentDto[] = [];
  orderNumber = 1;
  loading = false;
  private subscriptions: Subscription[] = [];
  Description: any;
  constructor(
    private location: Location,
    private fb: FormBuilder,
    private manualControlService: ManualControlServices,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private manualControlServices: ManualControlServices
  ) {
    this.parentId = route.snapshot.parent.parent.params['id'];

    this.manualControlForm = this.fb.group({
      OrderNumber: this.fb.control<number | null>(this.orderNumber, [
        Validators.required
      ]),
      objectName: this.fb.control<string | null>('', [Validators.required]),
      minTemp: this.fb.control<number | null>(null, [Validators.required]),
      maxTemp: this.fb.control<number | null>(null, [Validators.required]),
      Description: this.fb.control<string | null>('', [
        Validators.maxLength(1000)
      ])
    });
  }

  ngOnInit() {
    document.querySelector('body').classList.remove('opened');
    this.additionalData = {
      ApplicationId: BaseServices.ApplicationId,
      BusinessId: BaseServices.BusinessId,
      ParentId: this.parentId,
      ChildId: 0,
      Status: Status.Active,
      CreatedOn: new Date(),
      ModifiedBy: BaseServices.UserId,
      ModifiedOn: new Date(),
      ModuleName: 'Deviation'
    };
    this.upConfig = {
      title: 'MORE_ATTACHMENTS',
      titleAsLabel: true,
      editMode: true,
      windowedHeight: false,
      viewSwitch: false,
      showUserMeta: false,
      showSearchFilter: false,
      showUploadButton: true,
      showDeleteButton: true,
      uploaderUri: `${environment.BASE_URL}/${BaseServices.apiRoute(
        this.parentId
      )}foodsafety/file-upload`,
      addtionalData: this.additionalData
    };
    this.temperatureForm = this.fb.group({
      Name: [
        '',
        [Validators.required, ValidationService.checkAverageTemperature]
      ]
    });

    this.watchTemperature();
    this.parentId = this.route.snapshot.parent.parent.params['id'];
    this.subscriptions.push(
      this.route.params.subscribe((params: Params) => {
        let mId = params['mId'];
        this.manualId = +mId;

        if (mId) {
          let result = this.route.snapshot.data['edit'];

          if (result) {
            if (result.FoodControlDocument) {
              result.FoodControlDocument.forEach(element => {
                this.uploadedFiles.push(
                  HelperService.switchKeysCase(element, null, 'L')
                );
              });
              this.uploadedFiles = result.FoodControlDocument.filter(
                x => x.status !== 0
              );
            }
            this.createdOn = result.CreatedOn;
            this.minTemperature = +result.MinTemp;
            this.maxTemperature = +result.MaxTemp;
            this.ObjectName = result.ObjectName;
            this.Description = result.Description;
            this.manual = {
              objectName: result.ObjectName,
              Description: result.Description,
              OrderNumber: result.OrderNumber,
              minTemp: +result.MinTemp,
              maxTemp: +result.MaxTemp
            };
            this.manualControlForm.setValue(this.manual, {
              onlySelf: true
            });
          }
        } else {
          this.subscriptions.push(
            this.manualControlServices
              .getManualControlByParent(this.parentId)
              .subscribe(result => {
                if (result) {
                  this.orderNumber += result.length;
                  this.manualControlForm.controls.OrderNumber.setValue(
                    this.orderNumber
                  );
                }
              })
          );
        }
      })
    );

    this.TemperatureMin = [];
    if (this.minTemperature != null) {
      this.TemperatureMin.push({
        label: this.minTemperature.toString() + '\xB0C',
        value: this.minTemperature
      });
    }
    this.TemperatureMax = [];
    if (this.maxTemperature != null) {
      this.TemperatureMax.push({
        label: this.maxTemperature.toString() + '\xB0C',
        value: this.maxTemperature
      });
    }
  }

  /**
   * Starts observable for value changes in the temp dropdowns
   */
  watchTemperature() {
    this.validateTemperature();
    this.subscriptions.push(
      this.manualControlForm.valueChanges.subscribe(() => {
        this.validateTemperature();
      })
    );
  }

  /**
   * the temperature selection is only valid as long as the min temperature
   * is not a higher number than the max temperature
   */
  validateTemperature() {
    let minTemp = this.manualControlForm.controls.minTemp.value;
    let maxTemp = this.manualControlForm.controls.maxTemp.value;
    if (minTemp == null || maxTemp == null) {
      this.isTempValid = true;
      return;
    }
    this.isTempValid = minTemp <= maxTemp;
  }

  changemaxTemp() {
    this.TemperatureMax = [];
    let tempValue = -30;
    let maxtempValue = 100;
    if (tempValue != null) {
      this.subscriptions.push(
        this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
          for (let i = tempValue; i <= maxtempValue; i++) {
            this.TemperatureMax.push({
              label: i.toString() + '\xB0C',
              value: i
            });
          }
        })
      );
    }
  }

  changeminTemp() {
    this.TemperatureMin = [];
    let tempValue = -30;
    let maxtempValue = 100;
    if (tempValue != null) {
      this.subscriptions.push(
        this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
          for (let i = tempValue; i <= maxtempValue; i++) {
            this.TemperatureMin.push({
              label: i.toString() + '\xB0C',
              value: i
            });
          }
        })
      );
    }
  }

  Save() {
    this.loading == true;
    let formValue = this.manualControlForm.getRawValue();
    let foodControlObject = new FoodControl();
    foodControlObject.Id = this.manualId ? this.manualId : 0;
    foodControlObject.BusinessId = BaseServices.BusinessId;
    foodControlObject.Description = formValue.Description;
    foodControlObject.FoodSafetyId = Number(this.parentId);
    foodControlObject.ControlId = Number(this.parentId);
    foodControlObject.Status = Status.Active;
    foodControlObject.ObjectName = formValue.objectName;
    foodControlObject.FoodControlDocument = this.newUploadedFiles;
    foodControlObject.OrderNumber = formValue.OrderNumber;
    foodControlObject.MinTemp = (formValue.minTemp ?? 0).toString();
    foodControlObject.MaxTemp = (formValue.maxTemp ?? 0).toString();
    foodControlObject.CreatedBy = BaseServices.UserId;
    foodControlObject;
    if (this.manualId > 0) {
      foodControlObject.CreatedOn = this.createdOn;
      this.subscriptions.push(
        this.manualControlService
          .updateManualControl(foodControlObject)
          .subscribe(result => {
            this.notifications.success('UI_NOTIFICATIONS.SAVED');
            this.loading = false;
            this.saveAndClear();
          })
      );
    } else {
      this.subscriptions.push(
        this.manualControlService
          .createManualControl(foodControlObject)
          .subscribe((res: any) => {
            this.manualId = res.Id;
            this.notifications.success('UI_NOTIFICATIONS.SAVED');
            this.loading = false;
            this.saveAndClear();
          })
      );
    }
  }

  /**
   * file upload events
   * @param event {any}
   */
  saveUploaded(event: any) {
    if (event) {
      let eventType = event.eventName;
      switch (eventType) {
        case 'DeleteDefaultFile':
          if (event.item.data.id === 0) {
            // remove unsaved attachment
            this.newUploadedFiles = this.newUploadedFiles.filter(
              x => x.Path !== event.item.data.path
            );
            this.uploadedFiles = this.uploadedFiles.filter(
              x => x.path !== event.item.data.path
            );
            this.notifications.success('UI_NOTIFICATIONS.DELETED');
          } else {
            //  remove existing attachement
            this.subscriptions.push(
              this.manualControlService
                .deleteFoodControlAttachment(event.item.data.id)
                .subscribe((result: any) => {
                  if (result) {
                    // remove from display list
                    this.uploadedFiles = this.uploadedFiles.filter(
                      x => x.path !== event.item.data.path
                    );
                    this.notifications.success('UI_NOTIFICATIONS.DELETED');
                  }
                })
            );
          }
          break;
        default:
          let keyBindings = {
            Originalname: 'OriginalFileName',
            FileTypeId: 'FileType'
          };
          let deviationDoc = Object.assign({}, event, this.additionalData);
          deviationDoc.id = 0;
          deviationDoc.createdBy = BaseServices.UserId;
          deviationDoc.status = Status.Active;
          this.newUploadedFiles.push(
            HelperService.switchKeysCase(deviationDoc, keyBindings)
          );
          break;
      }
    }
  }

  saveAndClear() {
    setTimeout(() => {
      this.clear();
    }, 1000);
  }

  clear() {
    this.manualId = 0;
    this.orderNumber = 1;
    this.manualControlForm.reset({
      OrderNumber: this.orderNumber,
      objectName: '',
      minTemp: null,
      maxTemp: null,
      Description: ''
    });
    this.subscriptions.push(
      this.manualControlServices
        .getManualControlByParent(this.parentId)
        .subscribe(result => {
          if (result) {
            this.orderNumber = 1;
            this.orderNumber += result.length;
            this.manualControlForm.controls.OrderNumber.setValue(
              this.orderNumber
            );
          }
        })
    );
  }

  clearform() {
    this.uploadedFiles = [];
  }

  gotoBack() {
    setTimeout(() => {
      this.location.back();
    }, 1000);
  }

  onOrderNumber(e: any, limitNumber: any) {
    const limit = limitNumber;
    let charCode = e.which ? e.which : e.keyCode;
    if (
      e.target.value.length === limit ||
      (charCode > 31 && (charCode < 48 || charCode > 57))
    ) {
      e.preventDefault();
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub, i) => {
      sub.unsubscribe();
    });
  }
}
